<template lang="pug">
  footer.footer(:class="[{fix: this.footerFix}]")
    .footer__copir © 2019 TIWO.ru
    a(href='mailto:org@tiwo.ru' target="_blank").footer__mail org@tiwo.ru

</template>

<script>
export default {
  name: 'Footer',
  data: function() {
    return {
      footerFix: false,
    }
  },
  watch: {
    $route() {
      this.resize()
    }
  },
  mounted() {
    this.$nextTick(function() {
      window.addEventListener('resize', this.resize);
    })
  },
  methods: {
    resize() {
      let windowWidth = document.documentElement.clientWidth;
      const tablet = windowWidth  < 992;
      if(tablet && this.$route.name == 'activity') {
        this.footerFix = true;
      } else {
        this.footerFix = false;
      }
    },
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resize);
  }
}
</script>

<style lang="scss">
.footer{
  margin-top: auto;
  display: flex;
  align-items: center;
  border-top: 1px solid #e4e4e4;
  padding: 28px 35px;
  &.fix{
    margin-bottom: 70px;
  }
  &__copir{
    color: #161616;
    font-size: 16px;
    line-height: 25px;
    margin-right: 30px;
  }
  &__mail{
    color: #161616;
    font-size: 16px;
    line-height: 25px;
    text-decoration: none;
    &:hover{
      color: #008cff;
    }
  }
}
  
@media (max-width: 768px)  {
  .footer{
    padding: 10px 20px;
    &__copir,
    &__mail{
      font-size: 14px;
    }
  }
}
</style>
